export default __webpack_public_path__ + "static/media/loginImg.750bf57e.png";